import { CrudServiceBase } from '@utils';
import { Organization } from '@services/organization';

type Entity = Organization;

export class SubOrganizationService extends CrudServiceBase<Entity> {
	constructor() {
		super(Organization, 'organization/sub-org', { getAllPath: 'all' });
	}
}

export const subOrganizationService = new SubOrganizationService();
